module.exports = __webpack_public_path__ + "img/gdrive.b7d0eba3.png";